/** Atlas workloadType tag for electable/read-only secondaries (ODS-326). */
export const MONGO_OPERATIONAL_WORKLOAD_TYPE = 'OPERATIONAL' as const;

export const ODS_FLAG_NAMES = {
  // ODS-326: when on, secondary/secondaryPreferred reads use workloadType:OPERATIONAL
  // tags (off = untagged reads, prior behavior). Per-query call sites re-evaluate
  // this gate per request identity; connection-level reads bake the result once
  // at Mongoose connect (mongoConnections) and lag until reconnect/redeploy.
  MONGO_OPERATIONAL_READ_TAGS: 'ff-ods-326-mongo-operational-read-tags',
  // ODS-336: when on, RedisEventStream.streamEvents() destroys the client socket
  // immediately on abort (instead of waiting out the poll interval) and raises
  // XREAD BLOCK from 1s to 30s. Off = prior behavior (1s poll, no socket destroy).
  // Evaluated once per createEventStream() call and threaded down as a static
  // per-connection option, since a mid-stream flag flip must not change behavior
  // for a connection that is already blocked in xRead.
  REDIS_STREAM_ABORT_DESTROY: 'ff-ods-336-redis-stream-abort-destroy',
  // ODS-634: when on, decorateSitesWithPages bulk-fetches via
  // pages.find({site: {$in}}) (chunked). Off = per-site getAllPagesForSiteId
  // with mapLimit(8) (ODS-593 behavior). Backend-only; roll out by workspaceId.
  BULK_DECORATE_SITES_WITH_PAGES: 'ff-ods-634-bulk-decorate-sites-with-pages',
} as const;

export const ODS_DYNAMIC_CONFIG_NAMES = {
  MONGO_WEDGE_ENFORCEMENT: 'dc-ods-266-mongo-wedge-enforcement',
  // ODS-293: per-service maxStalenessSeconds (+ optional non-primary readPreference mode).
  MONGO_MAX_STALENESS: 'dc-ods-293-mongo-max-staleness',
  MONGO_DNS_LOOKUP: 'dc-ods-238-mongo-dns-lookup',
  // ODS-422: per-service Mongo maxPoolSize. Absent or malformed leaves the
  // built-in 10 default, so raising the pool is a per-service ramp (workspaces
  // chronic reason:timeout) rather than a fleet-wide flip. Baked at connect;
  // a flip only reaches a live pool after that pod restarts.
  MONGO_POOL_SIZE: 'dc-ods-422-mongo-pool-size',
  // ODS-420: per-service Mongo pool maxIdleTimeMS. Absent or malformed leaves
  // the built-in 30s default, so raising idle is a per-service ramp rather than
  // a fleet-wide flip. Baked into pool options when the client connects, so a
  // flip only reaches a live pool after that pod restarts.
  MONGO_POOL_IDLE: 'dc-ods-420-mongo-pool-idle',
} as const;
